import React, { useState } from 'react';
import { PartiesGroupInformationForm } from './PartiesGroupInformationForm';
import { useFormikContext } from 'formik';
import { eTransactionCategory } from '../../../ui-toolkit/enums/eTransactionType';
import { ePartyPurpose } from '../../../ui-toolkit/enums/ePartyPurpose';
import { ICreateOrderRequest } from '../../../ui-toolkit/orders/interfaces/createOrder/ICreateOrderRequest';

const defaultFocus = { doesAnyone: false, partyIndex: 0, signatoryIndex: 0 };

export const PartiesInformationForm: React.FC = () => {
  const { values } = useFormikContext<ICreateOrderRequest>();
  const [whoHasFocus, setWhoHasFocus] = useState(defaultFocus);

  if (values.transactionCategory === eTransactionCategory.Refinance) {
    return (
      <PartiesGroupInformationForm
        title={`Borrower(s) Information`}
        minimum={1}
        maximum={10}
        partyPurpose={ePartyPurpose.borrower}
        focus={whoHasFocus}
        setFocus={setWhoHasFocus}
      />
    );
  }

  return (
    <>
      <PartiesGroupInformationForm
        title={`Buyer(s) Information`}
        minimum={1}
        maximum={10}
        partyPurpose={ePartyPurpose.buyer}
        focus={whoHasFocus}
        setFocus={setWhoHasFocus}
      />
      <PartiesGroupInformationForm
        title={'Seller(s) Information'}
        minimum={0}
        maximum={10}
        partyPurpose={ePartyPurpose.seller}
        focus={whoHasFocus}
        setFocus={setWhoHasFocus}
      />
    </>
  );
};
